import {Component, computed, inject} from '@angular/core';
import {rxResource} from '@angular/core/rxjs-interop';
import {TranslocoPipe} from '@jsverse/transloco';
import {DirectusService, DirectusTranslatedItem} from '@frontend/directus';
import {FormFieldSelectComponent} from '../../../../../shared/components/inputs/form-field/form-field-select/form-field-select.component';

@Component({
  selector: 'app-tender-rejection-reason',
  imports: [TranslocoPipe, FormFieldSelectComponent],
  templateUrl: './tender-rejection-reason.component.html',
})
export class TenderRejectionReasonComponent {
  private readonly directusService = inject(DirectusService);

  readonly rejectionReasonsResource = rxResource({
    stream: () => this.directusService.loadDirectusDropdown('tender_rejection_reason'),
  });

  readonly rejectionReasons = computed(
    () => this.rejectionReasonsResource.value() ?? ([] as DirectusTranslatedItem[]),
  );
}
